import { useRef, useState } from "react"
import { Drawer, DrawerRef } from "../../../components/drawers/Drawer"
import FlexRow from "../../../components/base/FlexRow"
import Icon from "../../../components/base/Icon"
import { setDarkMode } from "../../../core/Global"
import { applyThemeChoice, getThemeChoice, ThemeChoice } from "../../../core/Metronic"
import { FontAwesomeIcons } from "../../../core/Types"
import "./ThemeMobile.css"


interface ThemeOption {
    id: ThemeChoice
    name: string
    desc: string
    icon: FontAwesomeIcons
}

const OPTIONS: ThemeOption[] = [
    // Called "Device" on phones (the desktop header toggle still says System).
    { id: "system", name: "Device", desc: "Match your device appearance", icon: "circle-half-stroke" },
    { id: "light", name: "Light", desc: "Always use light theme", icon: "sun-bright" },
    { id: "dark", name: "Dark", desc: "Always use dark theme", icon: "moon-stars" }
]

interface IProps {
    onClose: () => void
}

export default function ThemeMobile(props: IProps) {

    const drawer = useRef<DrawerRef>(null)
    const [selected, selectedSet] = useState<ThemeChoice>(getThemeChoice())

    const pick = (choice: ThemeChoice) => {
        const mode = applyThemeChoice(choice)
        setDarkMode(mode === "dark")
        selectedSet(choice)
    }

    return (
        <Drawer ref={drawer} title="Theme" onClose={props.onClose}>
            <div className="p-3">

                {OPTIONS.map(opt => {
                    const active = selected === opt.id
                    return (
                        <FlexRow key={opt.id}
                            className={`theme-option-row ${active ? "theme-option-row-active" : ""}`}
                            onClick={() => pick(opt.id)}>

                            <div className="theme-option-icon">
                                <Icon icon={opt.icon} type="solid" size={20} />
                            </div>

                            <div className="ms-4 flex-grow-1">
                                <div className="fs-5 fw-bold">{opt.name}</div>
                                <div className="text-muted fs-7">{opt.desc}</div>
                            </div>

                            {active &&
                                <Icon icon="check" type="solid" size={18} className="text-primary" />
                            }
                        </FlexRow>
                    )
                })}

            </div>
        </Drawer>
    )
}
